import * as Yup from 'yup'
import { SQUARE_IMAGE } from '../../../../fields'
import { listOfImagesShape } from '../../../../validations'

export const validationSchema = Yup.object({
  [SQUARE_IMAGE]: listOfImagesShape
})
